export const OpenCAPTCHA = true;
export const COUNTDOWN = 45;
